import { useId, useState } from 'react'
import type { SourceRef } from '../types/catalog'
import { sourceUrl } from '../lib/catalog'
import { linkClass } from './ui'

export default function SourceEvidence({ source, quote }: { source?: SourceRef; quote: string | null }) {
  const [expanded, setExpanded] = useState(false)
  const id = useId()
  const url = source ? sourceUrl(source.url) : null
  return <div className="mt-2 space-y-2 text-xs leading-6">
    {source ? <a href={url ?? `#source-${source.id}`} target={url ? '_blank' : undefined} rel={url ? 'noopener noreferrer' : undefined} className={`${linkClass} break-words`}>{source.title}</a> : <span className="text-muted">Source not supplied</span>}
    {quote && <>
      <button type="button" onClick={() => setExpanded(!expanded)} aria-expanded={expanded} aria-controls={expanded ? id : undefined} className={`${linkClass} block min-h-9`}>{expanded ? 'Hide excerpt' : 'Read excerpt'}</button>
      {expanded && <blockquote id={id} className="whitespace-pre-wrap break-words border-l-2 border-line pl-3 text-muted">{quote}</blockquote>}
    </>}
  </div>
}
